﻿/**
 * Параметры, передаваемые в адресной строке, не привязанные к контролам
 * */
window.queryFilterParams = {};

function toggleFiltersPanel(e: kendo.ui.ButtonClickEvent) {
    const toggleFiltersBtn = e.sender.element;
    const filtersId = toggleFiltersBtn.data('toggle-filters');
    const filtersElement = filtersId ? $(`#${filtersId}`) : $('.filters');

    if (filtersElement.is(':visible')) {
        localStorage.setItem(`${location.pathname} -showFilters`, 'false');
        toggleFiltersBtn.text('Показать панель фильтров');
    }
    else {
        localStorage.removeItem(`${location.pathname} -showFilters`);
        toggleFiltersBtn.text('Скрыть панель фильтров');
    }

    filtersElement.toggle();
    $('.k-widget[data-role="pivotconfigurator"]').toggle();
    $(window).trigger('resize');
}

function collectFilters() {
    const path = location.pathname.toLowerCase();
    const isDict = path.includes('dict');
    if ((isDict && window.getQueryParams()['Id'] && !(window as any).isLoaded) || path.includes('callservice/simplecall'))
        return;

    let filterString = '';
    const noValue = 'novalue';

    $('.filters input, .filters select, .filters .k-button-group').each(function () {
        const input = $(this);
        const role = input.data().role;

        if (input.hasClass('k-textbox')) {
            const control = this as HTMLInputElement;
            filterString += `${input[0].id}=${(!role && control.value) ? control.value : noValue}&`;
        }
        else if (input.hasClass('k-checkbox')) {
            const control = this as HTMLInputElement;
            filterString += `${control.name}=${control.checked ? '1' : '0'}&`;
        }
        else {
            switch (role) {
                case 'numerictextbox':
                case 'maskedtextbox':
                case 'textbox':
                case 'combobox': {
                    const [dataKey] = Object.keys(input.data()).filter(item => item.startsWith('kendo'));
                    const control = input.data(dataKey);
                    filterString += `${control?.element.attr('id')}=${control?.value() || noValue}&`;
                    break;
                }
                case 'multiselect': {
                    const control = input.data('kendoMultiSelect');
                    const value = control?.value();

                    if (value?.length) {
                        const dataLength = control?.dataSource.data().length;
                        const isAll = dataLength === value.length && dataLength !== 1;
                        filterString += `${control?.element.attr('id')}=${isAll ? 'CI_All' : value}&`;
                    }
                    else {
                        filterString += `${control?.element.attr('id')}=${noValue}&`;
                    }
                    break;
                }
                case 'datepicker': {
                    const control = input.data('kendoDatePicker');
                    const value = control?.value();
                    filterString += `${control?.element.attr('id')}=${value ? value.toLocaleDateString('RU-ru') : noValue}&`;
                    break;
                }
                case 'timepicker': {
                    const control = input.data('kendoTimePicker');
                    const value = control?.value();
                    filterString += `${control?.element.attr('id')}=${value ? value.toLocaleTimeString('RU-ru') : noValue}&`;
                    break;
                }
                case 'datetimepicker': {
                    const control = input.data('kendoDateTimePicker');
                    const value = control?.value();
                    filterString += `${control?.element.attr('id')}=${value ? value.toLocaleString('RU-ru') : noValue}&`;
                    break;
                }
                case 'buttongroup': {
                    const control = input.data('kendoButtonGroup');
                    filterString += `${control?.element.attr('id')}=${control?.selectedIndices.join()}&`;
                    break;
                }
            }
        }
    });

    const kanbanView = $('#kanbanView');
    if (kanbanView.length) {
        window.queryFilterParams['showKanban'] = kanbanView.is(':visible');
    }

    const grid = window.findFirstGrid();
    if (grid) {
        window.queryFilterParams['settings'] = window.getState(grid);
    }

    const scheduler = $('.k-scheduler').data('kendoScheduler');
    if (scheduler) {
        window.queryFilterParams['schedulerSettings'] = window.getSchedulerState(scheduler);
    }

    Object.keys(window.queryFilterParams).forEach((key) => {
        if (isDict && key === 'Id') return;
        filterString += `${key}=${window.queryFilterParams[key]}&`;
    });

    filterString = filterString.slice(0, -1);
    let pathName = location.pathname.toLowerCase();

    if (pathName.endsWith('/my'))
        pathName = pathName.replace('/my', '');
    if (pathName.endsWith('/fromme'))
        pathName = pathName.replace('/fromme', '');
    if (pathName.endsWith('/todo'))
        pathName = pathName.replace('/todo', '');
    if (pathName.endsWith('/tocheck'))
        pathName = pathName.replace('/tocheck', '');

    const newUrl = `${location.origin}${pathName}?IsFilter=0&${window.compressToBase64(filterString)}`;

    history.pushState({ path: newUrl }, '', newUrl);
}

function setFilters(grid: kendo.ui.Grid | kendo.ui.TreeList, withoutRebind: boolean) {
    const paramDictionary = window.getQueryParams();
    const noValue = 'novalue';

    Object.keys(paramDictionary).forEach(key => {
        const control = $(`#${key}`);

        const ms = control.data('kendoMultiSelect');
        if (ms) {
            let ids: (number | undefined)[];

            if (paramDictionary[key] === 'CI_All') {
                ids = ms.dataSource.data().map((a: { Id: number }) => a.Id);
                if (ids.includes(undefined)) {
                    ids = ms.dataSource.data().map((a: { Value: number }) => a.Value);
                }
                ms.value(ids);
            }
            else if (paramDictionary[key] === noValue) {
                ms.value(null);
            }
            else {
                const values = paramDictionary[key].split(paramDictionary[key].includes('%2C') ? '%2C' : ',');
                ids = values.map(Number);
                ms.value(ids);

                if (ms.dataSource.options.serverFiltering) {
                    window.updateDynamicMultiSelectItems(ms, ids.map((id) => ({
                        Id: id
                    })));
                }
            }
            ms.trigger('change');
            return;
        }

        const cb = control.data('kendoComboBox');
        if (cb) {
            if (paramDictionary[key] !== noValue) {
                cb.value(decodeURI(paramDictionary[key]));
                if (cb.dataSource.options.serverFiltering) {
                    cb.dataSource.read();
                }
            }
            else {
                cb.value('');
            }
            return;
        }

        const ntb = control.data('kendoNumericTextBox');
        if (ntb) {
            ntb.value(paramDictionary[key] !== noValue ? paramDictionary[key] : '');
            return;
        }

        const mtb = control.data('kendoMaskedTextBox');
        if (mtb) {
            mtb.value(paramDictionary[key] !== noValue ? paramDictionary[key] : '');
            return;
        }

        const tb = control.data('kendoTextBox');
        if (tb) {
            tb.value(paramDictionary[key] !== noValue ? decodeURI(paramDictionary[key]) : '');
            return;
        }

        const bg = control.data('kendoButtonGroup');
        if (bg) {
            bg.select(parseInt(paramDictionary[key]));
            bg.trigger('select');
            return;
        }

        const chb = control as JQuery<HTMLInputElement>;
        if (chb.hasClass('k-checkbox')) {
            if (paramDictionary[key] !== noValue) {
                $(chb)[0].checked = paramDictionary[key] === '1';
            }
        }

        paramDictionary[key] = paramDictionary[key].replace(/%E2%80%8E/g, ''); // #18843
        const dp = control.data('kendoDatePicker');
        if (dp) {
            dp.value(paramDictionary[key] !== noValue ? paramDictionary[key] : '');
            return;
        }

        const tp = control.data('kendoTimePicker');
        if (tp) {
            tp.value(paramDictionary[key] !== noValue ? decodeURI(paramDictionary[key]) : '');
            return;
        }

        const dtp = control.data('kendoDateTimePicker');
        if (dtp) {
            dtp.value(paramDictionary[key] !== noValue ? decodeURI(paramDictionary[key]) : '');
            return;
        }

        control.val(paramDictionary[key] !== noValue ? decodeURI(paramDictionary[key]) : '');

        if (!control.length && paramDictionary[key] !== noValue) {
            window.queryFilterParams[key] = decodeURI(paramDictionary[key]);
        }

        if (key === 'showKanban' && paramDictionary[key] === 'true') {
            const viewButton = $('#btToggleGridView').data('kendoButton');
            viewButton?.trigger('click');
        }
    });

    if (grid && !withoutRebind) {
        setTimeout(window.rebindDataSource, 0, grid);
    }
}

function applyFiltersFromQueryParams(grid: kendo.ui.Grid) {
    const isShowKanban: boolean = window.getQueryParams()?.showKanban === 'false';

    if (!location.search) {
        setFilters(grid, false);
    }
    else if (grid.element.is(':visible')) {
        setFilters(grid, !isShowKanban);
    }
}

function recollectFiltersOnSourceChange() {
    const grid = window.findFirstGrid();
    if (!grid) return;

    const timeoutFunc = () => setTimeout(window.collectFilters, 100);

    if (grid instanceof kendo.ui.Grid && grid.pager) {
        grid.one('dataBound', (e: kendo.ui.GridDataBoundEvent) => {
            const pageSizesDdl = $(e.sender.pager.element).find('[data-role=\'dropdownlist\']').data('kendoDropDownList');
            pageSizesDdl?.bind('change', timeoutFunc);
        });
        grid.pager.bind('change', timeoutFunc);
    }

    grid.bind('columnShow', timeoutFunc);
    grid.bind('columnHide', timeoutFunc);
    grid.bind('sort', timeoutFunc);
    grid.bind('group', timeoutFunc);
}

window.toggleFiltersPanel = toggleFiltersPanel;
window.collectFilters = collectFilters;
window.setFilters = setFilters;
window.applyFiltersFromQueryParams = applyFiltersFromQueryParams;
window.recollectFiltersOnSourceChange = recollectFiltersOnSourceChange;